<div class="dates-table-container">
  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)" class="mat-elevation-z2">

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <!-- Event Date Column -->
    <ng-container matColumnDef="eventDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Date</th>
      <td mat-cell *matCellDef="let row">{{ formatDate(row.eventDate) }}</td>
    </ng-container>

    <!-- Reminder Date Column -->
    <ng-container matColumnDef="reminderDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Reminder Date</th>
      <td mat-cell *matCellDef="let row">{{ formatDate(row.reminderDate) }}</td>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let row">{{ row.type }}</td>
    </ng-container>

    <!-- Assigned To Column -->
    <ng-container matColumnDef="assignedTo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned To</th>
      <td mat-cell *matCellDef="let row">{{ formatAssignedTo(row.assignedTo) }}</td>
    </ng-container>

    <!-- Assigned By Column -->
    <ng-container matColumnDef="assignedBy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned By</th>
      <td mat-cell *matCellDef="let row">{{ formatAssignedBy(row.assignedBy) }}</td>
    </ng-container>

    <!-- Action Completed Column -->
    <ng-container matColumnDef="actionCompleted">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Action Completed</th>
      <td mat-cell *matCellDef="let row">{{ row.actionCompleted ? 'Yes' : 'No' }}</td>
    </ng-container>

    <!-- Edit Column -->
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef>Edit</th>
      <td mat-cell *matCellDef="let row">
        <button mat-button color="accent" (click)="editCriticalDate(row)">
          Edit
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
</div>
